export const isAuthError = (errorCode?: number) => errorCode === 401;
